export default [
	{//流程引擎
		path: 'workflow_design',
		name: 'm_workflow_design',
		props: route => route.params,
		component: () => import('@/pages/workflow/workflow_design_list.vue')
	},
	{//流程引擎
		path: 'workflow_form',
		name: 'm_workflow_form',
		props: route => route.params,
		component: () => import('@/pages/workflow/workflow_form_model_list.vue')
	},
];